import { DialogOptions } from 'components/core/Dialog/common/Dialog';
import { FormattedMessage, formatTranslation, unsafeTranslationKey } from 'intl';
import { translationKeyToString } from 'intl/types/translationKey';
import { UserTranslationKeys } from 'intl/keys';
import { IntlShape } from 'react-intl';
import { AccessLevelModel } from 'shared/domain/issue/mapping/accessLevel/model/types';
import { getAccessLevelLabel } from 'shared/domain/issue/mapping/accessLevel/toOnView/getAccessLevelLabel';
import { CommonTranslationKeys } from 'intl/keys';

export function getConfirmationDialogParams(
  intl: IntlShape,
  currentAccessLevel: AccessLevelModel,
  newAccessLevel: AccessLevelModel,
  userLabel: string
): DialogOptions {
  const currentAccessLevelLabel = getAccessLevelLabel(currentAccessLevel);
  const newAccessLevelObject = getAccessLevelLabel(newAccessLevel);
  return {
    maxWidth: 500,
    catchOnCancel: false,
    fullWidth: false,
    title: <FormattedMessage id={UserTranslationKeys.changeConfirmationTitle} />,
    description: (
      <span>
        <FormattedMessage id={UserTranslationKeys.changeConfirmationDescription}
          values={{
            userLabel,
            currentAccess: formatTranslation(intl, unsafeTranslationKey(currentAccessLevelLabel),),
            newAccess: (
              <strong>
                {formatTranslation(intl, unsafeTranslationKey(newAccessLevelObject),)}
              </strong>
            ),
          }}
        />
      </span>
    ),
    customControllerLabels: [
      translationKeyToString(CommonTranslationKeys.cancel),
      translationKeyToString(CommonTranslationKeys.change),
    ],
  };
}
